<template>
    <div id="recibo">
        <div class="border border-dark mb-3" v-for="(fin, index) in finList" :key="index" >
            <div class="w-100 border-bottom border-dark">
                <div class="p-3 d-flex justify-content-between">
                    <h2 class="font-weight-bold">RECIBO</h2>
                    <h2 class="font-weight-bold">R$ {{ fin.vlr | formatValue(2, true) }}</h2>
                </div>                       
            </div>
            <div class="w-100 border-bottom border-dark">
                <div class="p-3 d-flex flex-column">
                    <h5 v-if="receberTab">Recebido de: {{ fin.nome }}</h5>
                    <h5 v-if="pagarTab">Recebido de: {{ filial.nome }}</h5>
                    <h5>Título: {{ fin.doc }}</h5>
                    <h5>Data de emissão: {{ fin.dtemissao | formatData }}</h5>
                    <h5>Data de vencimento: {{ fin.data | formatData }}</h5>
                    <h5>A imporância de <span class="uppercase">{{ extensoMoeda(fin.vlr) }}</span></h5>
                </div>
            </div>
            <div class="w-100">
                <div class="row p-3 d-flex justify-content-start">
                    <div class="col-12">
                        <h5>CIDADE DA FILIAL, {{ dataSemiExtenso(fin.data) }}</h5>
                    </div>
                </div>
                <div class="row d-flex justify-content-end">
                    <h5 class="p-3 text-center" v-if="receberTab">
                        _______________________________________________________________________<br />
                        {{ filial.nome }}
                    </h5>
                    <h5 class="p-3 text-center" v-if="pagarTab">
                        _______________________________________________________________________<br />
                        {{ fin.nome }}
                    </h5>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [ 'finList', 'receberTab', 'pagarTab', 'filial' ],

    methods: {
        extensoMoeda(val) {
            var extenso = require('extenso')
            const value = val.toFixed(2).replace('.',',')
            const valor = extenso(value, { mode: 'currency', currency: { type: 'BRL' } })
            return valor
        },
        dataSemiExtenso(date) {
            const meses = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"]
            let data = new Date(date);
            let dataFormatada = ((data.getDate() + " " + meses[(data.getMonth())] + " " + data.getFullYear()))
            return dataFormatada
        },

        relatorio (prtHtml) {

            // const prtHtml = document.getElementById('relatorio').innerHTML

            let stylesHtml = '';
            for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
                stylesHtml += node.outerHTML;
            }
            const WinPrint = window.open('', '', 'left=0,top=0,toolbar=0,scrollbars=0,status=0');

            if (!WinPrint) {
              return this.$erpToastError('Habilite a exibição de pop-ups')
            }

            WinPrint.document.write(`
                <!DOCTYPE html>
                <html>
                    <head>
                        ${stylesHtml}
                    </head>
                    <body>
                        <div>
                            <div class="w-100 p-3">
                                ${prtHtml}
                            </div>
                        </div>
                    </body>
                </html>
            `);

            WinPrint.document.close()
            WinPrint.focus()
            WinPrint.print()
            WinPrint.close()
            this.$emit('close')
        },
    },

    mounted () {
        let vm = this
        setTimeout(() => {
            const prtHtml = document.getElementById('recibo').innerHTML
            vm.relatorio(prtHtml)
        }, 1000);
    },

    created () {

    },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/forms/financeiro-print-recibo.vue